export const SELECTOR_DISCOUNT_ID = (state) => 
	state.discounts.discountId

export const SELECTOR_DISCOUNT = (state) =>
	state.discounts.discount